import { render, staticRenderFns } from "./BrazilRadioField.vue?vue&type=template&id=1d1c6f14&scoped=true&"
import script from "./BrazilRadioField.vue?vue&type=script&lang=js&"
export * from "./BrazilRadioField.vue?vue&type=script&lang=js&"
import style0 from "./BrazilRadioField.vue?vue&type=style&index=0&id=1d1c6f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c6f14",
  null
  
)

export default component.exports